import { SxProps, Theme } from '@mui/material';

export const makeUnprintableStyle = (sx?: SxProps<Theme>): SxProps<Theme> => ({
  '@media print': {
    display: 'none',
  },
  ...sx,
});
